import isEmpty from 'lodash.isempty';
import { useQueryClient } from '../../lib';
import { getAuthTokenKey, getNetworkKey } from '../../utils/keys';
export const networkUpdater = newNetwork => old => {
    let network = newNetwork;
    if (typeof newNetwork === 'function') {
        network = newNetwork(old);
    }
    return {
        ...old,
        ...network,
    };
};
export const authTokenUpdater = newAuthToken => old => {
    return {
        ...old,
        ...newAuthToken,
        network: networkUpdater(newAuthToken === null || newAuthToken === void 0 ? void 0 : newAuthToken.network)(old === null || old === void 0 ? void 0 : old.network),
    };
};
export const navigationSlateReducer = (network, updatedSlateIds, slates) => Object.keys(network.navigationSlates)
    .map(key => {
    const slate = network.navigationSlates[key];
    if (!slate)
        return undefined;
    if (updatedSlateIds.includes(slate.id)) {
        return { [key]: slates.find(s => s.id === slate.id) };
    }
    return { [key]: slate };
})
    .reduce((preValue, value) => ({ ...preValue, ...value }), network.navigationSlates);
const findNetwork = (queryClient) => {
    const queries = queryClient.getQueriesData({
        queryKey: getNetworkKey(),
    });
    let network;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const data = query === null || query === void 0 ? void 0 : query[1];
        network = {
            ...network,
            ...data,
        };
    });
    return network;
};
const findNetworkInAuthToken = (queryClient) => {
    const queries = queryClient.getQueriesData({
        queryKey: getAuthTokenKey(),
    });
    let network;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const authToken = query === null || query === void 0 ? void 0 : query[1];
        network = {
            ...network,
            ...authToken === null || authToken === void 0 ? void 0 : authToken.network,
        };
    });
    return network;
};
export const useCachedNetwork = () => {
    const queryClient = useQueryClient();
    const network = {
        ...findNetwork(queryClient),
        ...findNetworkInAuthToken(queryClient),
    };
    if (!isEmpty(network))
        return network;
};
//# sourceMappingURL=useCachedNetwork.js.map